<template>
  <div id="container" v-if="fetch_data">
    <section id="event">
      <form @submit="update" id="form">
        <div class="wrap">
          <div class="register_step flex">
            <div class="step_box flex on">
              <div class="num">1</div>
              <p>申し込み<br class="sp">フォーム</p>
            </div>
            <div class="step_box flex">
              <div class="num">2</div>
              <p>申し込み内容の<br class="sp">確認</p>
            </div>
            <div class="step_box flex">
              <div class="num">3</div>
              <p>決済情報の<br class="sp">入力</p>
            </div>
            <div class="step_box flex">
              <div class="num">4</div>
              <p>参加申し込みを<br class="sp">受け付けました</p>
            </div>
          </div>

          <div class="cts_box">
            <h2 class="sub_ttl"><span>申し込み {{ model.title }}</span></h2>
            <h3 class="min_ttl">概要</h3>
            <div class="df_table">
              <dl class="flex">
                <dt>名称</dt>
                <dd>
                  {{ model.title }}
                  <div><img v-bind:src="model.video_picture_url" alt="" style="width: 400px"></div>
                </dd>
              </dl>

              <dl class="flex">
                <dt>視聴期限</dt>
                <dd>
                  <template v-if="model.access_period === 'access_period_no_7_days'">
                    7日間視聴可
                  </template>
                  <template v-else>
                    ※ 無制限
                  </template>

                </dd>
              </dl>
              <dl class="flex">
                <dt>説明</dt>
                <dd v-html="model.description"></dd>
              </dl>
              <dl class="flex">
                <dt>価格</dt>
                <dd>
                  {{ delimited(model.rank_price) }}円･税込
                </dd>
              </dl>
            </div>
          </div>

          <div class="cts_box claim workshop" v-bind:class="{ 'point-disabled': false }">
            <h3 class="min_ttl">ポイントの利用</h3>
            <p class="lead_txt">
              ポイントを利用する場合は、ポイント数を入力の上「ポイントを利用する」ボタンを押してください。</p>
            <table class=""><!-- ポイント利用できない場合はclass="point_none" を追加 -->
              <tbody>
              <tr class="head">
              </tr>
              <tr>
                <td class="date">現在のポイント数</td>
                <td class="price">{{ delimited(model.total_points) }}<span>ポイント</span></td>
                <td class="point flex">
                  <h3 class="sp">ポイント利用額（1ポイント＝1円）</h3>
                  <p>ご利用ポイントを入力</p>
                  <div class="point_input">
                    <input type="text" v-model="use_points"
                           @input="use_points = replaceFullToNumber(use_points)"
                           v-bind:disabled="model.total_points === 0"
                           maxlength="6" class="point">
                    <p class="caution">最大 {{ model.usable_points }}
                      ポイントまでご利用いただけます</p>
                    <p>1ポイント＝1円として利用できます</p>
                  </div>
                  <p class="bold">ポイント</p>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="btn">
                  <button type="button" class="submit light skeleton"
                          v-bind:disabled="model.total_points === 0"
                          @click="usePointClicked">ポイントを利用する
                  </button>
                </td>
                <!--<td colspan="3" class="btn"><input type="submit" class="submit light skeleton" value="現在ポイントの利用はできません" disabled></td> ポイント利用できない場合-->
              </tr>
              </tbody>
            </table>
          </div>

          <div class="cts_box">
            <h3 class="min_ttl">お会計内容</h3>
            <p class="lead_txt">講義動画視聴のための合計額を表示しています。</p>
            <div class="register_box">
              <dl class="flex">
                <dt>{{ model.title }}</dt>
                <dd class="item">{{ current_user.rank_label }}</dd>
                <dd class="price">¥{{ delimited(model.rank_price) }}</dd>
              </dl>
              <dl class="flex" v-if="point">
                <dt>ポイントのご利用</dt>
                <dd class="item"></dd>
                <dd class="price">-{{ delimited(point) }}</dd>
              </dl>
              <dl class="flex total">
                <dt></dt>
                <dd class="item">お会計合計：</dd>
                <dd class="price">¥{{ delimited(total_price) }}</dd>
              </dl>
            </div>
          </div>

          <div class="df_table">
            <dl class="flex">
              <dt>おなまえ</dt>
              <dd>{{ current_user.last_name }} {{ current_user.first_name }}</dd>
            </dl>
            <dl class="flex">
              <dt>塾生番号</dt>
              <dd>{{ current_user.number }}</dd>
            </dl>
          </div>

          <div class="button_wrap mt50">
            <p class="alnC mb20" v-if="false">
              すべての項目に入力したら<br class="sp">こちらのボタンを押してください。
            </p>
            <input type="submit" class="submit light arrow" value="申し込み内容の確認">
          </div>

        </div>
      </form>
    </section>
  </div>
</template>


<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      fetch_data: null,
      model: null,
      point: 0,
      use_points: 0,
      total_price: null
    }
  },
  mounted() {
    // form token
    this.setFormToken('SnsPostSale')
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}sns/sns_post_sale.json`, {
            params: {
              id: this.$route.params.id,
            }
          })
          .then(response => {
            this.fetch_data = response.data
            this.model = response.data

            this.point = this.$store.state.sns_post_sale ? this.$store.state.sns_post_sale.use_points : 0
            this.use_points = this.point
            this.total_price = this.$store.state.sns_post_sale ? this.$store.state.sns_post_sale.total_price : this.model.rank_price
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
    usePointClicked() {
      if (isNaN(this.use_points)) {
        this.use_points = 0
      } else {
        this.use_points = Number(this.use_points)
        if (this.use_points > this.model.usable_points) {
          this.use_points = this.model.usable_points
        }
      }
      this.point = this.use_points
      this.total_price = this.model.rank_price - this.use_points
    },
    update(event) {
      event.preventDefault()
      this.$store.state.sns_post_sale  = {
        use_points: this.use_points,
        total_price: this.total_price
      }
      this.$router.push({name: 'SnsPostSaleConfirm', params: {id: this.$route.params.id}})
    }
  }
}
</script>

<style lang="scss">
.order_group.expire {
  opacity: 0.8;
  background: #eee;
  pointer-events: none;
}

</style>